<template>
  <div class="homepage backoffice">

    <b-container v-if="loading">
      <spinner />
    </b-container>
    <b-container v-else>

      <div class="backoffice--sidebar no-print">
        <div class="backoffice--sidebar--action">
          <!-- TODO icona stampa -->
          <div class="backoffice--sidebar--icon" @click="print()"><font-awesome-icon size="lg" icon="globe"/></div>
        </div>
      </div>

      <h2>Richiesta: {{request_id}}</h2>
      <user-request :user_request="user_request" :pax="pax"/>

    </b-container>

  </div>
</template>
<script>

import Spinner from '@/components/atoms/spinner'
import UserRequest from '@/components/blocks/user-request'
import {get_active_quote} from "@/api";

export default {
  name: 'view_user-request',
  components: {
    'spinner': Spinner,
    'user-request': UserRequest,
  },
  props: {
    request_id: Number,
  },
  data() {
    return {
      loading: true,
      user_request: {},
      pax: {}
    }
  },
  computed: {
  },
  created()
  {
  },
  mounted() {

    this.log(this.request_id)

    get_active_quote({
      request_id: this.request_id
    })
        .then( response => {
          this.log(response)

          this.user_request = response.user_request
          this.user_request.messages = (response.messages)? response.messages : []

          this.pax = (response.quote.pax)? response.quote.pax : {}

          this.loading = false
        })
  },
  methods:{

    print: function(){
      // ps. se per mila motivi la pagina sta ancora caricando, non stampa
      window.print()
    },

  },
}
</script>

<style lang="scss">

.backoffice--sticky{
  display: none;
}

.backoffice
{
  &--sidebar
  {
    margin-top:$grid-gutter-width;
    width:80px;
    position:fixed;
    top:$backoffice-head-height;
    left:0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding-left: $grid-gutter-width/2;
    &--action
    {
      width:100%;
      display:inline-flex;
      align-items:center;
      justify-content: center;
      padding:0.5rem 1rem;
      margin-bottom:1rem;
      border:2px solid $primary;
      color:$primary;
      border-radius: $border-radius;
      transition:$transition-base;
      font-size: 20px;
      cursor: pointer;
      &:hover
      {
        background: $primary;
        color: $white;
      }
      &--icon
      {
      }
    }
  }
  &--content
  {
    margin-top:40px;
  }
  &--head
  {
    position:fixed;
    z-index: 1;
    top:$backoffice-head-height;
    left:$backoffice-sidebar-width + $grid-gutter-width/2;
    right:$grid-gutter-width/2;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding:$grid-gutter-width/2 0 $grid-gutter-width/2 0;
    background:$white;
    .form-group
    {
      margin-right:1rem;
      margin-bottom:0;
    }
    label
    {
      margin-bottom:0;
      font-size: $font-size-sm;
    }
  }
  .status
  {
    color:$info;
    span
    {
      display:inline-block;
      padding-right:10px;
      font-size: 12px;
      text-transform:uppercase;
      font-weight: bold;
    }
  }
  .modal-request
  {
    border-color:$info;
    background:$info;
    color:$white;
    text-transform: uppercase;
    font-weight: bold;
  }
  &--quote
  {
    display:flex;
  }
  &--actions
  {
    display:flex;
    align-items:center;
    justify-content: flex-start;
  }
  &--action
  {
    font-size:14px;
    display:inline-flex;
    align-items:center;
    justify-content: flex-end;
    padding:0.25rem 0.75rem;
    margin-left:1rem;
    border:1px solid $secondary;
    color:$secondary;
    border-radius: $border-radius;
    transition:$transition-base;
    background:$white;
    cursor: pointer;
    &:hover
    {
      background: $secondary;
      color: $white;
    }
    &:first-child
    {
      margin-left:0;
    }
    &--icon
    {
      margin-right:0.5rem;
    }
  }
}
</style>
